import { render } from "./ReviCoLogo.vue?vue&type=template&id=72a1233e&ts=true"
import script from "./ReviCoLogo.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReviCoLogo.vue?vue&type=script&setup=true&lang=ts"

import "./ReviCoLogo.vue?vue&type=style&index=0&id=72a1233e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/common/ReviCoLogo.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72a1233e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72a1233e', __exports__)) {
    api.reload('72a1233e', __exports__)
  }
  
  module.hot.accept("./ReviCoLogo.vue?vue&type=template&id=72a1233e&ts=true", () => {
    api.rerender('72a1233e', render)
  })

}


export default __exports__